export default __webpack_public_path__ + "static/media/Saksham.71082ffd.jpg";